import { makeObservable, observable, action, reaction,computed } from 'mobx';
import axios, { storeGet } from "../utils/axios";
import historyVars from "../utils/historyVars";
import errors from "../reducers/errors";

import configStore from "./data_loaders/configStore";
import dataStore from "./data_loaders/dataStore";
import memoryStore from "./data_loaders/memoryStore";
import searchStore from "./data_loaders/searchStore";
import filter from "../utils/filter";
import { history } from "../history_mobx";

import Item from "../components/Blog/Item";
import ItemMedium from "../components/Blog/ItemMedium";
import ItemSmall from "../components/Blog/ItemSmall";

class blogStore {
  config={
    sorter:[],
    view_mode:"big",
    show_view_chooser:true,
    title:"",
    modes:{
      big:{ component:"BlogItem", wrap_class:"up12 margin m-size-3 xl-size-4 h-size-3 s-size-2", },
      medium:{ component:"BlogItemMedium", wrap_class:"up12 margin s-size-1 m-size-2 h-size-2", },
      // small:{ component:"BlogItemSmall", wrap_class:"up12 margin s-size-4 m-size-9 h-size-11", }
    }
  }
  constructor(par,config) {
    this.par=par;
    this.configStore=new configStore(this);
    this.memoryStore=new memoryStore(this);
    this.searchStore=new searchStore(this);
    this.dataStore=new dataStore(this);

    const t=par.stores.translateStore.t.blog;
    if(!config) {
      config={};
    }

    this.configStore.setConfig({
      layout:[],
      layout_marker: "blog_store",
      default_filter:"name",
      disable_str_mask:true,
      default_order:{"created_time":"desc"},
      data_route:"/api/blog",
      pathname_only:history.location.pathname,
      system_filter:config.filter || null,
      fields:[
        filter.string({code: "name", name: t.TITLE, }),
        filter.string({code: "preview_text", name: t.POST_TEXT }),
        filter.integer({code: "id", name:"ID" }),
        filter.static_list({code: "published", name: "Черновик" },[{id:"0",name:"Да",},{id:"1",name:"Нет",}]),
        filter.user({code: "created_by", name:"Автор" }),
        filter.yes_no({code: "property_NEWS_POST", name:t.NEWS_POST }),
        filter.static_list({code: "reward_reward_id", name:"Награда" },[{id:"30",name:"Блог недели"}])
      ]
    });
    makeObservable(this, {
      config: observable,
      view_mode: computed,
    });

    this.prepareConfig();

  }
  get view_mode() {
    return this.config.modes[this.config.view_mode];
  }
  prepareConfig() {
    const ord = this.par.stores.translateStore.t.order;
    this.config.title=this.par.stores.translateStore.t.blog.BLOG_TITLE;
    this.config.sorter=[
      {name: ord.DATE_ADDED2, code: 'created_time', start: 'desc', default: true},
      {name: ord.RATING, code: 'rating_mark', start: 'desc', default: false},
      {name: ord.COMMENTS, code: 'c_comments_value', start: 'desc', default: false},
      {name: ord.DATE_MODIFIED, code: 'modified_time', start: 'desc', default: false},

      {name: this.par.stores.translateStore.t.viewcounter.VIEW_UNIQUE, code: 'view_unique', start: 'desc', default: false},
      {name: this.par.stores.translateStore.t.viewcounter.VIEW_ALL, code: 'view_all', start: 'desc', default: false},
    ];
  }
  destroy() {
    const arr=[this.memoryStore];
    for(let i in arr) {
      arr[i].destroy();
    }
  }
  getStores() {
    return {
      configStore: this.configStore,
      dataStore: this.dataStore,
      memoryStore: this.memoryStore,
      searchStore: this.searchStore,
      dataCombiner: this,
    }
  }
  /*fetchMe() {
    storeGet(`/api/user/me`, this.me);
  }*/

}


export default blogStore;
